import mergeToNew from "@insite/client-framework/Common/mergeToNew";
import StyledWrapper from "@insite/client-framework/Common/StyledWrapper"
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import searchProducts from "@insite/client-framework/Store/Components/ProductSelector/Handlers/SearchProducts";
import { getProductSelector } from "@insite/client-framework/Store/Components/ProductSelector/ProductSelectorSelectors";
import translate from "@insite/client-framework/Translate";
import { ProductAutocompleteItemModel } from "@insite/client-framework/Types/ApiModels";
import TextField, { TextFieldPresentationProps } from "@insite/mobius/TextField"
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import React, { ReactNode, useEffect, useState } from "react"
import { connect, ResolveThunks } from "react-redux";
import { css } from "styled-components";

const ESC_KEY = 27;
const DOWN_KEY = 40;
const UP_KEY = 38;
const TAB_KEY = 9;
const ENTER_KEY = 13;

interface OwnProps {
    label: string;
    value: string;
    errorMessage: ReactNode | string;
    onKeyDown:  (event: React.KeyboardEvent<HTMLInputElement>) => void;
    onChange?: (event: React.ChangeEvent<HTMLInputElement>) => void;
    onBeginSearch?: () => void;
    onClearSearch?: () => void;
    extendedStyles?: XCSearchTextFieldStyles;
    dataTestSelector?: string;
    searching?: boolean;
}

export interface XCSearchTextFieldStyles {
    container?: InjectableCss;
    textFieldWrapper?: InjectableCss;
    textField?: TextFieldPresentationProps;
}

const xcSearchTextFieldStyles: XCSearchTextFieldStyles = {
    container: {
        css: css`
            width: 100%;
        `,
    },
    textFieldWrapper: {
        css: css`
            width: 100%;
        `,
    },
    textField: {
        css: css`
            width: 100%;
        `,
    },
};

const mapStateToProps = (state: ApplicationState) => {
    const { isSearching, searchResults, selectedProductInfo, errorType } = getProductSelector(state);
    return {
        isSearching,
        searchResults,
        selectedProductInfo,
        errorType,
    }
};

const mapDispatchToProps = {
    searchProducts,
};

type Props = OwnProps & ReturnType<typeof mapStateToProps> & ResolveThunks<typeof mapDispatchToProps>;

const XCSearchTextField = ({
    label,
    value,
    errorMessage,
    isSearching,
    searchResults,
    selectedProductInfo,
    extendedStyles,
    dataTestSelector,
    searching,
    onKeyDown,
    onChange,
    onBeginSearch,
}: Props) => {

    const [styles] = useState(() => mergeToNew(xcSearchTextFieldStyles, extendedStyles));

    /**
     * This function listens for the ENTER or TAB keys being pressed.
     */
    const handleKeyDown = (event: React.KeyboardEvent<HTMLInputElement>) => {
        onKeyDown(event);
    }

    /**
     * Triggers the onChange event which sents the event up to the parent.
     */
    const handleOnChange = (event: React.ChangeEvent<HTMLInputElement>) => {       
        onChange && onChange(event);
    }

    return (
        <StyledWrapper {...styles.container}>
            <StyledWrapper {...styles.textFieldWrapper}>
                <TextField 
                    {...styles.textField}
                    label={label}
                    value={value}
                    placeholder={translate("Enter product number")}
                    disabled={searching}
                    error={errorMessage}
                    readOnly={!!selectedProductInfo}
                    onKeyDown={(e) => handleKeyDown(e)}
                    onChange={(e) => handleOnChange(e)}
                    data-test-selector={dataTestSelector}
                />
            </StyledWrapper>
        </StyledWrapper>
    )
}

export default connect(mapStateToProps, mapDispatchToProps)(XCSearchTextField);
